import { registerBlockType } from "@wordpress/blocks"
import Edit from "./edit"

registerBlockType("puroclean/urgent-damage", {
  edit: Edit,
  save: () => null // Server-side rendered block
}) 